import React from "react";
import { observer } from "mobx-react";
import { CreditMovementViewStore } from "../../store";
import { CreditMovementViewForm } from "./CreditMovementViewForm";
import { ErrorDialog } from "../../../../common/controls";

export type CreditMovementViewProps = {
  creditMovementViewStore: CreditMovementViewStore;
};

export const CreditMovementView: React.FC<CreditMovementViewProps> = observer(
  ({ creditMovementViewStore }) => {
    return (
      <div>
        <CreditMovementViewForm
          typeOptions={creditMovementViewStore.getTypeOptions()}
          type={creditMovementViewStore.typeValue}
          delta={creditMovementViewStore.deltaValue}
          balanceAfter={creditMovementViewStore.balanceAfterValue}
          movementAt={creditMovementViewStore.movementAtValue}
          detail={creditMovementViewStore.detailValue}
          editionKey={creditMovementViewStore.editionKeyValue}
          editionName={creditMovementViewStore.editionNameValue}
          purchaseValue={creditMovementViewStore.purchaseValue}
          onPrint={(handlePrint: () => void) =>
            creditMovementViewStore.printCreditMovement(handlePrint)
          }
          onCancel={() => creditMovementViewStore.cancelCreditMovement()}
          onEdit={
            creditMovementViewStore.isEditEnabled
              ? () => creditMovementViewStore.editCreditMovement()
              : undefined
          }
        />
        <ErrorDialog
          open={creditMovementViewStore.errorDialogOpened}
          title={creditMovementViewStore.errorTitle}
          description={creditMovementViewStore.errorDescription}
          onClose={() => creditMovementViewStore.closeErrorDialog()}
        />
      </div>
    );
  }
);
